// Load all action handlers

const req = require.context('.', false, /^\.\/(?!index).*\.js$/);
const actionHandlers = req.keys().map((file) => req(file).default);
// eslint-disable-next-line
const { buildExports } = require('lib/action-index');

// Export actions and 'reducers'
Object.assign(module.exports, buildExports(actionHandlers));
